import { sampleClips } from "./sampleData.js";
export function getAnniversarySample(staticAssetBaseUrls, themeId = "pop-hearts", themeVersion) {
    return {
        version: 1,
        occasionId: "anniversary",
        themeId,
        themeVersion,
        staticAssetBaseUrls,
        videoFrame: {
            width: 1920,
            height: 1080,
            fps: 30,
        },
        introGreeting: {
            enabled: true,
            messages: [
                "Thank you for being the ray of sunshine in my life ❤️",
                "Here's to many more wonderful moments together",
                "Can't wait for our next adventure, my love",
            ],
        },
        outroGreeting: {
            enabled: true,
            messages: [
                "Happy Anniversary! ❤️",
                "Here's to many more wonderful moments together",
                "Can't wait for our next adventure, my love",
            ],
        },
        faceCollageEnabled: true,
        userInput: {
            titleMessage: "Happy 50th Anniversary!",
        },
        music: {
            enabled: true,
            volumeDuringClips: "low",
            song: {
                id: "a-minor-waltz",
                name: "A Minor Waltz",
                duration: 140.329796,
                urls: [
                    "https://memento-sandbox-music.s3.us-east-2.amazonaws.com/A_Minor_Waltz.mp3",
                ],
            },
        },
        logo: {
            enabled: false,
            size: "medium",
            urls: [],
        },
        branding: {
            enabled: true,
        },
        clips: sampleClips,
    };
}
